export class ServiceForecast {
  id            : string
  ml_report_id     : string
  date          : Date
  observation   : string
}
